// extracted by mini-css-extract-plugin
export var equalColumn = "_ci-0";